import { render, staticRenderFns } from "./Newsliste.vue?vue&type=template&id=00eb7198"
import script from "./Newsliste.vue?vue&type=script&lang=js"
export * from "./Newsliste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports